(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__SEREIN_PRODUCT_CARD_VARIANT_BELT__) return;
    window.__SEREIN_PRODUCT_CARD_VARIANT_BELT__ = true;

    const triggerSelector = '[data-product-card-variant-item] [data-hover-src]';

    const findMainImage = (card) => {
      const selectors = [
        '.product-card__image img',
        '.card__media img',
        '.media img',
        'img.motion-reduce',
        'img:not(.product-card-variant-belt__image)'
      ];

      for (const selector of selectors) {
        const image = card.querySelector(selector);
        if (image && !image.classList.contains('product-card-variant-belt__image')) return image;
      }
      return null;
    };

    const preview = (trigger) => {
      const src = trigger.dataset.hoverSrc;
      const srcset = trigger.dataset.hoverSrcset;
      const variantId = trigger.dataset.variantId;
      const card = trigger.closest('product-card, .product-card, .card-wrapper, .grid__item, li');
      if (!card) return;

      if (variantId) {
        card.dataset.selectedVariantId = variantId;
        const quickAdd = card.querySelector('[data-pick-quick]');
        const variantInput = quickAdd?.querySelector('input[name="id"]');
        if (quickAdd) quickAdd.dataset.selectedVariantId = variantId;
        if (variantInput) variantInput.value = variantId;
      }

      const image = findMainImage(card);
      if (src && image) {
        const picture = image.closest('picture');
        const sources = picture ? picture.querySelectorAll('source') : [];
        image.setAttribute('src', src);
        if (srcset) {
          image.setAttribute('srcset', srcset);
          sources.forEach((source) => source.setAttribute('srcset', srcset));
        }
      }

      card.querySelectorAll('.product-card-variant-belt__pill').forEach((pill) => pill.classList.remove('is-active'));
      trigger.classList.add('is-active');
    };

    const getTrigger = (event) => event.target instanceof Element ? event.target.closest(triggerSelector) : null;

    document.addEventListener('pointerover', (event) => {
      const trigger = getTrigger(event);
      if (!trigger) return;
      if (event.relatedTarget instanceof Node && trigger.contains(event.relatedTarget)) return;
      preview(trigger);
    });

    document.addEventListener('focusin', (event) => {
      const trigger = getTrigger(event);
      if (trigger) preview(trigger);
    });

    document.addEventListener('touchstart', (event) => {
      const trigger = getTrigger(event);
      if (trigger) preview(trigger);
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* Clean color sessions + exact selected-belt order are intentionally separate. */
  class PremiumHorizontalFacets {
    constructor() {
      this.shell = document.querySelector('[data-premium-page-filter]');
      this.mobileStrip = document.querySelector('[data-premium-mobile-filter-strip]');
      this.form = document.querySelector('.premium-page-filter__form');
      this.autoInStock = document.querySelector('[data-auto-in-stock-url]');
      this.priceFilters = document.querySelectorAll('[data-sq-rp3]');
      this.colorGroupPills = document.querySelectorAll('[data-color-group-pill]');
      this.densityButtons = document.querySelectorAll('[data-premium-density]');
      this.mobileDensityButtons = document.querySelectorAll('[data-premium-mobile-density]');
      this.loadingNextPage = false;
      this.colorApplyDelay = 1100;
      this.colorApplyTimer = null;
      this.pendingColorUrl = null;
      this.colorSelectionSessionActive = false;
      this.sizeApplyDelay = 1100;
      this.sizeApplyTimer = null;
      this.pendingSizeUrl = null;
      this.sizeSelectionSessionActive = false;

      this.initPageFilterLayout();
      this.initAutoHeaderOffset();
      this.initAutoInStock();
      this.initPriceFilters();
      this.initColorGroups();
      this.initColorSelectionBelts();
      this.initSizeGroups();
      this.initLegacyColorLabelsCleanup();
      this.initDensity();
      this.initMobileDensity();
      this.initMobileDrawer();
      this.initMobileSortClose();
      this.initMobileMenuProtection();
      this.initInfiniteScroll();
    }

    initAutoHeaderOffset() {
      const root = document.documentElement;
      const desktopQuery = window.matchMedia('(min-width: 750px)');

      const headerSelectors = [
        '#shopify-section-header',
        '.shopify-section-header',
        '.shopify-section-header-sticky',
        'sticky-header',
        '.header-wrapper',
        'header.header',
        'header'
      ];

      const toolbarSelectors = [
        '.sq-dual-category__compact',
        '.sq-dual-category__compact-row',
        '.sq-dual-category-compact',
        '[data-sq-dual-category-compact]',
        '[data-sq-compact-category]',
        '[data-collection-toolbar]',
        '[data-product-grid-toolbar]',
        '.collection-toolbar',
        '.collection__toolbar',
        '.collection-toolbar-wrapper',
        '.product-grid__toolbar',
        '.product-grid-toolbar',
        '.facets-container',
        '.facets-vertical-sort',
        '.collection-category-bar',
        '.collection-bar',
        '.collection-tabs',
        '.collection-nav',
        '[class*="collection"][class*="toolbar"]',
        '[class*="product-grid"][class*="toolbar"]'
      ];

      const isVisible = (element) => {
        if (!element || !document.documentElement.contains(element)) return false;

        const rect = element.getBoundingClientRect();
        const style = window.getComputedStyle(element);

        return (
          rect.width > 0 &&
          rect.height > 0 &&
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          Number(style.opacity || 1) > 0
        );
      };

      const isFilterUI = (element) => Boolean(
        element.closest(
          '[data-premium-page-filter], [data-premium-mobile-filter-strip], .premium-mobile-filter-drawer'
        )
      );

      const readRootPixels = (name) => {
        const value = parseFloat(window.getComputedStyle(root).getPropertyValue(name));
        return Number.isFinite(value) ? value : 0;
      };

      const getPinnedHeaderBottom = () => {
        let bottom = 0;

        headerSelectors.forEach((selector) => {
          document.querySelectorAll(selector).forEach((element) => {
            if (!isVisible(element)) return;

            const rect = element.getBoundingClientRect();
            const style = window.getComputedStyle(element);
            const declaredTop = parseFloat(style.top);
            const top = Number.isFinite(declaredTop) ? declaredTop : 0;
            const pinned =
              (style.position === 'fixed' && rect.bottom > 0) ||
              (style.position === 'sticky' && rect.top <= top + 2 && rect.bottom > top);

            if (pinned) bottom = Math.max(bottom, rect.bottom);
          });
        });

        return Math.max(0, Math.ceil(bottom));
      };

      const clearToolbarMarker = () => {
        document.querySelectorAll('[data-premium-collection-toolbar]').forEach((element) => {
          element.removeAttribute('data-premium-collection-toolbar');
        });
        root.classList.remove('premium-collection-toolbar-detected');
      };

      const findToolbarState = (layout, headerBottom) => {
        const layoutRect = layout.getBoundingClientRect();
        const collectionSection =
          layout.closest('.shopify-section, [id^="shopify-section-"], main') || document;
        const candidates = new Set();

        toolbarSelectors.forEach((selector) => {
          collectionSection.querySelectorAll(selector).forEach((element) => candidates.add(element));
          if (collectionSection !== document) {
            document.querySelectorAll(selector).forEach((element) => candidates.add(element));
          }
        });

        let winner = null;
        let winnerScore = -Infinity;

        candidates.forEach((element) => {
          if (!isVisible(element) || isFilterUI(element)) return;
          if (element.matches('header, header *, footer, footer *')) return;

          const rect = element.getBoundingClientRect();
          const style = window.getComputedStyle(element);
          const isBeforeLayout = Boolean(
            element.compareDocumentPosition(layout) & Node.DOCUMENT_POSITION_FOLLOWING
          );
          const nearLayout = Math.abs(layoutRect.top - rect.bottom) <= 320;
          const usefulWidth = rect.width >= Math.min(window.innerWidth * 0.42, 500);
          const toolbarHeight = rect.height >= 20 && rect.height <= 190;

          if ((!isBeforeLayout && !nearLayout) || !usefulWidth || !toolbarHeight) return;

          const declaredTop = parseFloat(style.top);
          const stickyTop = Number.isFinite(declaredTop) ? declaredTop : headerBottom;
          const isFixed = style.position === 'fixed' && rect.bottom > headerBottom;
          const isStickyPinned =
            style.position === 'sticky' &&
            rect.top <= Math.max(headerBottom, stickyTop) + 3 &&
            rect.bottom > headerBottom + 2;
          const isThemePinned =
            root.classList.contains('sq-dual-category-active') &&
            rect.top <= headerBottom + 8 &&
            rect.bottom > headerBottom + 2;
          const isPinned = isFixed || isStickyPinned || isThemePinned;
          const semanticBonus = element.matches(toolbarSelectors.join(',')) ? 1500 : 0;
          const pinnedBonus = isPinned ? 10000 : 0;
          const proximity = 1200 - Math.min(Math.abs(layoutRect.top - rect.bottom), 1200);
          const score = pinnedBonus + semanticBonus + proximity + rect.width / 100;

          if (score > winnerScore) {
            winnerScore = score;
            winner = { element, rect, isPinned };
          }
        });

        clearToolbarMarker();

        if (!winner) {
          return {
            exists: false,
            pinned: false,
            bottom: headerBottom
          };
        }

        winner.element.setAttribute('data-premium-collection-toolbar', '');
        root.classList.add('premium-collection-toolbar-detected');

        return {
          exists: true,
          pinned: winner.isPinned,
          bottom: winner.isPinned
            ? Math.max(headerBottom, Math.ceil(winner.rect.bottom))
            : headerBottom
        };
      };

      let rafId = 0;
      let locked = false;
      let frozenOffset = null;
      let lastOffset = null;
      let lastLayout = null;

      const applyOffset = (value) => {
        const next = Math.max(0, Math.ceil(value));
        if (next === lastOffset) return;

        lastOffset = next;
        root.style.setProperty('--premium-filter-top', `${next}px`);
        root.style.setProperty('--premium-filter-mobile-top', `${next}px`);
      };

      const setLockClass = (layout, state) => {
        if (lastLayout && lastLayout !== layout) {
          lastLayout.classList.remove('is-premium-stuck');
        }

        lastLayout = layout;
        layout.classList.toggle('is-premium-stuck', state);
        root.classList.toggle('premium-filter-is-stuck', state);
      };

      const measure = ({ reset = false } = {}) => {
        rafId = 0;

        const layout = document.querySelector(
          '.premium-filter-layout[data-premium-sticky-boundary], .premium-filter-layout'
        );
        const stickyElement = desktopQuery.matches ? this.shell : this.mobileStrip;

        if (!layout || !stickyElement || !document.documentElement.contains(stickyElement)) {
          locked = false;
          frozenOffset = null;
          root.classList.remove('premium-filter-is-stuck');
          clearToolbarMarker();
          return;
        }

        if (reset) {
          locked = false;
          frozenOffset = null;
        }

        const headerBottom = getPinnedHeaderBottom();
        const toolbar = findToolbarState(layout, headerBottom);
        const themeOffset = Math.ceil(readRootPixels('--sq-dual-category-safe-offset'));
        const liveOffset = Math.max(
          headerBottom,
          toolbar.pinned ? toolbar.bottom : 0,
          themeOffset
        );

        if (!locked || frozenOffset === null) {
          applyOffset(liveOffset);
        }

        const effectiveOffset = locked && frozenOffset !== null ? frozenOffset : liveOffset;
        const layoutRect = layout.getBoundingClientRect();
        const stickyRect = stickyElement.getBoundingClientRect();
        const stickyHeight = Math.min(
          Math.max(stickyRect.height, 1),
          Math.max(window.innerHeight - effectiveOffset - 1, 1)
        );
        const toolbarReady = !toolbar.exists || toolbar.pinned;
        const reachedLine = layoutRect.top <= effectiveOffset + 1;
        const roomToLock = layoutRect.bottom > effectiveOffset + stickyHeight + 1;
        const shouldLock = toolbarReady && reachedLine && roomToLock;

        if (shouldLock && !locked) {
          locked = true;
          frozenOffset = liveOffset;
          applyOffset(frozenOffset);
        } else if (!shouldLock && locked) {
          locked = false;
          frozenOffset = null;
          applyOffset(liveOffset);
        }

        setLockClass(layout, shouldLock);
      };

      const schedule = (options = {}) => {
        if (rafId) return;
        rafId = window.requestAnimationFrame(() => measure(options));
      };

      measure({ reset: true });
      [80, 260, 760].forEach((delay) => {
        window.setTimeout(() => schedule({ reset: !locked }), delay);
      });

      window.addEventListener('scroll', () => schedule(), { passive: true });
      window.addEventListener('resize', () => schedule({ reset: true }), { passive: true });
      window.addEventListener('orientationchange', () => schedule({ reset: true }));
      window.addEventListener('pageshow', () => schedule({ reset: true }));
      document.addEventListener('shopify:section:load', () => schedule({ reset: true }));

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(() => {
          if (!locked) schedule({ reset: true });
        });

        const layout = document.querySelector('.premium-filter-layout');
        if (layout) observer.observe(layout);

        headerSelectors.forEach((selector) => {
          document.querySelectorAll(selector).forEach((element) => observer.observe(element));
        });
      }
    }

    initPageFilterLayout() {
      if (!this.shell && !this.mobileStrip) return;

      const findGrid = () => {
        const selectors = [
          '#product-grid',
          '.product-grid',
          '.grid.product-grid',
          '.collection .grid',
          '.collection__products .grid',
          'product-grid',
          'ul.grid'
        ];

        for (const selector of selectors) {
          const grid = document.querySelector(selector);
          if (grid) return grid;
        }

        return null;
      };

      const moveIntoLayout = () => {
        const grid = findGrid();

        if (!grid) return;

        let layout = grid.closest('.premium-filter-layout');

        if (!layout) {
          layout = document.createElement('div');
          layout.className = 'premium-filter-layout';
          layout.setAttribute('data-premium-sticky-boundary', '');

          const gridParent = grid.parentNode;

          if (!gridParent) return;

          gridParent.classList.add('premium-filter-layout-host');
          gridParent.insertBefore(layout, grid);
          layout.appendChild(grid);
        } else if (layout.parentElement) {
          layout.parentElement.classList.add('premium-filter-layout-host');
          layout.setAttribute('data-premium-sticky-boundary', '');
        }

        /*
         * Keep the mobile toolbar and desktop sidebar in the same tall
         * container as the product grid. This prevents sticky positioning
         * from ending when the original facets block ends.
         */
        if (this.mobileStrip && this.mobileStrip.parentElement !== layout) {
          layout.insertBefore(this.mobileStrip, layout.firstChild);
        }

        if (this.shell && this.shell.parentElement !== layout) {
          const gridInLayout = layout.querySelector(
            '#product-grid, .product-grid, .grid.product-grid, product-grid, ul.grid'
          );

          if (gridInLayout) {
            layout.insertBefore(this.shell, gridInLayout);
          } else {
            layout.appendChild(this.shell);
          }
        }

        const gridInLayout = layout.querySelector(
          '#product-grid, .product-grid, .grid.product-grid, product-grid, ul.grid'
        );

        if (this.mobileStrip && this.mobileStrip !== layout.firstElementChild) {
          layout.insertBefore(this.mobileStrip, layout.firstChild);
        }

        if (
          this.shell &&
          gridInLayout &&
          this.shell.nextElementSibling !== gridInLayout
        ) {
          layout.insertBefore(this.shell, gridInLayout);
        }

        document.body.classList.add('premium-filter-layout-ready');
      };

      moveIntoLayout();

      window.addEventListener('load', moveIntoLayout, { once: true });
      document.addEventListener('shopify:section:load', moveIntoLayout);

      const gridSelector =
        '#product-grid, .product-grid, .grid.product-grid, product-grid, ul.grid';
      const observer = new MutationObserver((mutations) => {
        const gridWasInserted = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some((node) => {
            if (!(node instanceof Element)) return false;
            return node.matches(gridSelector) || Boolean(node.querySelector(gridSelector));
          })
        );

        if (gridWasInserted) moveIntoLayout();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    initAutoInStock() {
      if (!this.autoInStock) return;

      const url = this.autoInStock.dataset.autoInStockUrl;

      if (!url) return;

      window.location.replace(url);
    }

    initPriceFilters() {
      this.priceFilters.forEach((priceFilter) => {
        const stage = priceFilter.querySelector('[data-sq-rp3-stage]');
        const range = priceFilter.querySelector('[data-sq-rp3-range]');
        const minHandle = priceFilter.querySelector('[data-sq-rp3-min-handle]');
        const maxHandle = priceFilter.querySelector('[data-sq-rp3-max-handle]');
        const minInput = priceFilter.querySelector('[data-sq-rp3-min-input]');
        const maxInput = priceFilter.querySelector('[data-sq-rp3-max-input]');
        const rangeText = priceFilter.querySelector('[data-sq-rp3-range-text]');
        const minText = priceFilter.querySelector('[data-sq-rp3-min-text]');
        const maxText = priceFilter.querySelector('[data-sq-rp3-max-text]');
        const liveRegion = priceFilter.querySelector('[data-sq-rp3-live]');

        if (!stage || !range || !minHandle || !maxHandle || !minInput || !maxInput) return;

        const limit = Math.max(0, Number(priceFilter.dataset.priceLimit) || 0);
        const currency = priceFilter.dataset.currency || 'USD';
        let minimum = Math.max(0, Math.min(limit, Number(priceFilter.dataset.priceMinimum) || 0));
        let maximum = Math.max(minimum, Math.min(limit, Number(priceFilter.dataset.priceMaximum) || limit));
        let activeHandle = null;
        let submitTimer = null;
        let visualResetTimer = null;
        let splitMode = false;

        const clamp = (value, low, high) => Math.min(Math.max(value, low), high);
        const valueToPercent = (value) => (limit > 0 ? (value / limit) * 100 : 50);
        const percentToValue = (percent) => {
          if (limit <= 0) return 0;
          return Math.round((clamp(percent, 0, 100) / 100) * limit);
        };

        const formatMoney = (value) => {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
              style: 'currency',
              currency,
              maximumFractionDigits: 0
            }).format(Math.round(value));
          } catch (error) {
            return `$${Math.round(value)}`;
          }
        };

        const updateHiddenInputs = () => {
          minInput.value = minimum > 0 ? String(minimum) : '';
          maxInput.value = maximum < limit ? String(maximum) : '';
        };

        const updateSplitMode = () => {
          if (limit <= 0) {
            splitMode = false;
            stage.classList.remove('is-split');
            stage.classList.add('is-merged', 'is-zero-limit');
            return;
          }

          stage.classList.remove('is-zero-limit');
          const stageWidth = stage.getBoundingClientRect().width;
          if (!stageWidth || !rangeText) return;

          const selectedWidth = ((maximum - minimum) / Math.max(limit, 1)) * stageWidth;
          const textWidth = rangeText.scrollWidth + 30;
          const enterAt = Math.max(82, textWidth - 8);
          const leaveAt = enterAt + 18;

          if (splitMode) {
            if (selectedWidth >= leaveAt) splitMode = false;
          } else if (selectedWidth <= enterAt) {
            splitMode = true;
          }

          stage.classList.toggle('is-split', splitMode);
          stage.classList.toggle('is-merged', !splitMode);
        };

        const render = () => {
          const minPercent = valueToPercent(minimum);
          const maxPercent = valueToPercent(maximum);
          const minMoney = formatMoney(minimum);
          const maxMoney = formatMoney(maximum);

          stage.style.setProperty('--sq-rp3-min', `${minPercent}%`);
          stage.style.setProperty('--sq-rp3-max', `${maxPercent}%`);
          stage.classList.toggle('is-collapsed', maximum === minimum);
          stage.classList.toggle('is-zero-limit', limit <= 0);
          stage.setAttribute('aria-disabled', limit <= 0 ? 'true' : 'false');

          if (rangeText) rangeText.textContent = limit <= 0 ? minMoney : `${minMoney} – ${maxMoney}`;
          if (minText) minText.textContent = minMoney;
          if (maxText) maxText.textContent = maxMoney;
          if (liveRegion) liveRegion.textContent = `Selected price range: ${minMoney} to ${maxMoney}`;

          minHandle.setAttribute('aria-valuenow', String(minimum));
          minHandle.setAttribute('aria-valuemax', String(maximum));
          minHandle.setAttribute('aria-valuetext', minMoney);
          maxHandle.setAttribute('aria-valuemin', String(minimum));
          maxHandle.setAttribute('aria-valuenow', String(maximum));
          maxHandle.setAttribute('aria-valuetext', maxMoney);

          updateHiddenInputs();
          updateSplitMode();
        };

        const priceApplyDelay = 1900;

        const setAdjustingState = (active, delay = 0) => {
          window.clearTimeout(visualResetTimer);

          if (active) {
            stage.classList.add('is-adjusting');
            return;
          }

          visualResetTimer = window.setTimeout(() => {
            stage.classList.remove('is-adjusting');
          }, delay);
        };


        const scheduleSubmit = () => {
          const form = priceFilter.closest('form');
          if (!form) return;

          window.clearTimeout(submitTimer);
          submitTimer = window.setTimeout(() => {
            if (activeHandle) {
              scheduleSubmit();
              return;
            }

            form.dispatchEvent(new Event('input', { bubbles: true }));
            form.dispatchEvent(new Event('change', { bubbles: true }));

            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }
          }, priceApplyDelay);
        };

        const pointerValue = (event) => {
          const rect = stage.getBoundingClientRect();
          if (!rect.width) return 0;
          return percentToValue(((event.clientX - rect.left) / rect.width) * 100);
        };

        const setValue = (kind, value) => {
          if (kind === 'min') {
            minimum = clamp(value, 0, maximum);
          } else {
            maximum = clamp(value, minimum, limit);
          }
          render();
        };

        const startDrag = (event, kind) => {
          event.preventDefault();
          if (limit <= 0) return;
          activeHandle = kind;
          setAdjustingState(true);
          const handle = kind === 'min' ? minHandle : maxHandle;
          handle.classList.add('is-dragging');
          handle.setPointerCapture?.(event.pointerId);
          setValue(kind, pointerValue(event));
          scheduleSubmit();
        };

        const drag = (event) => {
          if (!activeHandle) return;
          event.preventDefault();
          setValue(activeHandle, pointerValue(event));
          scheduleSubmit();
        };

        const stopDrag = (event) => {
          if (!activeHandle) return;
          const handle = activeHandle === 'min' ? minHandle : maxHandle;
          handle.classList.remove('is-dragging');
          handle.releasePointerCapture?.(event.pointerId);
          activeHandle = null;
          setAdjustingState(false, 220);
          scheduleSubmit();
        };

        const keyMove = (event, kind) => {
          const smallStep = Math.max(1, Math.round(limit / 100));
          const largeStep = Math.max(10, Math.round(limit / 10));
          let value = kind === 'min' ? minimum : maximum;

          switch (event.key) {
            case 'ArrowLeft':
            case 'ArrowDown':
              value -= smallStep;
              break;
            case 'ArrowRight':
            case 'ArrowUp':
              value += smallStep;
              break;
            case 'PageDown':
              value -= largeStep;
              break;
            case 'PageUp':
              value += largeStep;
              break;
            case 'Home':
              value = kind === 'min' ? 0 : minimum;
              break;
            case 'End':
              value = kind === 'min' ? maximum : limit;
              break;
            default:
              return;
          }

          event.preventDefault();
          setAdjustingState(true);
          setValue(kind, value);
          setAdjustingState(false, 280);
          scheduleSubmit();
        };

        minHandle.addEventListener('pointerdown', (event) => startDrag(event, 'min'));
        maxHandle.addEventListener('pointerdown', (event) => startDrag(event, 'max'));
        minHandle.addEventListener('pointermove', drag);
        maxHandle.addEventListener('pointermove', drag);
        minHandle.addEventListener('pointerup', stopDrag);
        maxHandle.addEventListener('pointerup', stopDrag);
        minHandle.addEventListener('pointercancel', stopDrag);
        maxHandle.addEventListener('pointercancel', stopDrag);
        minHandle.addEventListener('keydown', (event) => keyMove(event, 'min'));
        maxHandle.addEventListener('keydown', (event) => keyMove(event, 'max'));

        stage.addEventListener('pointerdown', (event) => {
          if (limit <= 0) return;
          if (event.target.closest('[data-sq-rp3-min-handle], [data-sq-rp3-max-handle]')) return;

          const value = pointerValue(event);
          const nearest = Math.abs(value - minimum) <= Math.abs(value - maximum) ? 'min' : 'max';
          setAdjustingState(true);
          setValue(nearest, value);
          setAdjustingState(false, 280);
          scheduleSubmit();
        });

        render();

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(updateSplitMode);
          observer.observe(stage);
        }
      });
    }

    getColorOrderStorageKey(filterParam) {
      return `premiumColorSelectionOrder:${window.location.pathname}:${filterParam}`;
    }

    readColorSelectionOrder(filterParam) {
      if (!filterParam) return [];

      try {
        const stored = window.sessionStorage.getItem(
          this.getColorOrderStorageKey(filterParam)
        );
        const parsed = stored ? JSON.parse(stored) : [];

        return Array.isArray(parsed)
          ? parsed.filter((value) => typeof value === 'string' && value.length > 0)
          : [];
      } catch (error) {
        return [];
      }
    }

    writeColorSelectionOrder(filterParam, order) {
      if (!filterParam) return;

      try {
        window.sessionStorage.setItem(
          this.getColorOrderStorageKey(filterParam),
          JSON.stringify(Array.from(new Set(order)))
        );
      } catch (error) {
        // Filtering still works when browser storage is unavailable.
      }
    }

    getRawColorGroupValues(pill) {
      return String(pill?.dataset.groupValues || '')
        .split('||')
        .map((value) => value.trim())
        .filter(Boolean);
    }

    getAllColorFilterParams(url = null) {
      const params = new Set();

      document
        .querySelectorAll('[data-color-group-pill][data-filter-param]')
        .forEach((pill) => {
          const filterParam = pill.dataset.filterParam;
          if (filterParam) params.add(filterParam);
        });

      /* Also catch color parameters already present in the URL. */
      const sourceUrl = url || new URL(this.pendingColorUrl || this.pendingSizeUrl || window.location.href);
      sourceUrl.searchParams.forEach((value, key) => {
        if (/(^|[._-])(color|colour)([._-]|$)/i.test(key)) params.add(key);
      });

      return Array.from(params);
    }

    clearAllColorSelectionOrders() {
      this.getAllColorFilterParams().forEach((filterParam) => {
        this.writeColorSelectionOrder(filterParam, []);
      });
    }

    getColorValueOwners(filterParam) {
      const groupMap = new Map();

      document
        .querySelectorAll('[data-color-group-pill][data-filter-param]')
        .forEach((pill) => {
          if (pill.dataset.filterParam !== filterParam) return;

          const groupKey = pill.dataset.colorGroupKey;
          const displayOrder = Number(pill.dataset.colorDisplayOrder);

          if (!groupKey || groupMap.has(groupKey)) return;

          groupMap.set(groupKey, {
            groupKey,
            displayOrder: Number.isFinite(displayOrder) ? displayOrder : 999,
            values: this.getRawColorGroupValues(pill)
          });
        });

      const owners = new Map();
      const groups = Array.from(groupMap.values()).sort(
        (a, b) => a.displayOrder - b.displayOrder
      );

      /*
       * A raw Shopify shade can match more than one broad color word, such as
       * "rose gold". Assign every raw value to only the first primary group
       * in the fixed sidebar order so one click cannot activate extra colors.
       */
      groups.forEach((group) => {
        group.values.forEach((value) => {
          if (!owners.has(value)) owners.set(value, group.groupKey);
        });
      });

      return owners;
    }

    getColorGroupValues(pill) {
      const filterParam = pill?.dataset.filterParam;
      const groupKey = pill?.dataset.colorGroupKey;
      const rawValues = this.getRawColorGroupValues(pill);

      if (!filterParam || !groupKey) return [];

      const owners = this.getColorValueOwners(filterParam);

      return rawValues.filter((value) => owners.get(value) === groupKey);
    }

    isColorGroupActiveInUrl(pill, url) {
      const filterParam = pill?.dataset.filterParam;
      const values = this.getColorGroupValues(pill);

      if (!filterParam || !values.length) return false;

      const activeValues = new Set(url.searchParams.getAll(filterParam));
      return values.some((value) => activeValues.has(value));
    }

    syncColorGroupStatesFromUrl(url, onlyFilterParam = null) {
      document.querySelectorAll('[data-color-group-pill]').forEach((candidate) => {
        const filterParam = candidate.dataset.filterParam;

        if (!filterParam) return;
        if (onlyFilterParam && filterParam !== onlyFilterParam) return;

        const values = this.getColorGroupValues(candidate);
        const isActive = values.length
          ? this.isColorGroupActiveInUrl(candidate, url)
          : false;

        candidate.hidden = values.length === 0;
        candidate.classList.toggle('is-active', isActive);
        candidate.dataset.groupActive = isActive ? 'true' : 'false';
        candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        /* The sidebar stays in its original primary-color order. */
        const displayOrder = Number(candidate.dataset.colorDisplayOrder);
        if (Number.isFinite(displayOrder)) {
          candidate.style.order = String(displayOrder);
        }
      });
    }

    scheduleColorApply(url) {
      const destination = url.toString();
      this.pendingColorUrl = destination;
      this.pendingSizeUrl = destination;
      window.clearTimeout(this.colorApplyTimer);
      window.clearTimeout(this.sizeApplyTimer);

      this.colorApplyTimer = window.setTimeout(() => {
        const nextDestination = this.pendingColorUrl || this.pendingSizeUrl;
        this.pendingColorUrl = null;
        this.pendingSizeUrl = null;
        this.colorApplyTimer = null;
        this.sizeApplyTimer = null;

        if (nextDestination) {
          window.location.assign(nextDestination);
        }
      }, this.colorApplyDelay);
    }

    queueColorGroupChange(pill, options = {}) {
      const removeOnly = options.removeOnly === true;
      const filterParam = pill?.dataset.filterParam;
      const groupKey = pill?.dataset.colorGroupKey;
      const values = this.getColorGroupValues(pill);

      if (!filterParam || !groupKey || !values.length) return;

      const url = new URL(this.pendingColorUrl || this.pendingSizeUrl || window.location.href);

      /*
       * The first normal color click starts a brand-new color session.
       * Remove every color-filter parameter first, even when Shopify exposes
       * more than one color parameter. Only colors clicked in this 1.1-second
       * session can remain active or appear in the custom belt.
       */
      if (!removeOnly && !this.colorSelectionSessionActive) {
        this.colorSelectionSessionActive = true;

        this.getAllColorFilterParams(url).forEach((colorParam) => {
          url.searchParams.delete(colorParam);
        });

        this.clearAllColorSelectionOrders();
      }

      const wasActive = this.isColorGroupActiveInUrl(pill, url);
      const existingValues = url.searchParams.getAll(filterParam);
      const groupValueSet = new Set(values);
      const remainingValues = existingValues.filter(
        (value) => !groupValueSet.has(value)
      );

      url.searchParams.delete(filterParam);
      remainingValues.forEach((value) => {
        url.searchParams.append(filterParam, value);
      });

      const shouldAdd = !removeOnly && !wasActive;

      if (shouldAdd) {
        values.forEach((value) => {
          url.searchParams.append(filterParam, value);
        });
      }

      url.searchParams.delete('page');
      this.pendingColorUrl = url.toString();

      const selectionOrder = this.readColorSelectionOrder(filterParam)
        .filter((key) => key !== groupKey);

      if (shouldAdd) selectionOrder.push(groupKey);
      this.writeColorSelectionOrder(filterParam, selectionOrder);

      /*
       * Update every desktop/mobile color copy from the pending URL, not the
       * stale loaded HTML. This makes every click register immediately and
       * guarantees that only active session colors appear in the belt.
       */
      this.syncColorGroupStatesFromUrl(url);

      document.querySelectorAll('[data-color-group-pill]').forEach((candidate) => {
        if (
          candidate.dataset.filterParam === filterParam &&
          candidate.dataset.colorGroupKey === groupKey
        ) {
          candidate.classList.add(shouldAdd ? 'is-selecting' : 'is-removing');
        }
      });

      window.setTimeout(() => {
        document.querySelectorAll('[data-color-group-pill]').forEach((candidate) => {
          if (
            candidate.dataset.filterParam === filterParam &&
            candidate.dataset.colorGroupKey === groupKey
          ) {
            candidate.classList.remove('is-selecting', 'is-removing');
          }
        });
      }, 260);

      this.initColorSelectionBelts(shouldAdd ? groupKey : null);
      this.scheduleColorApply(url);
    }

    initColorGroups() {
      this.syncColorGroupStatesFromUrl(new URL(window.location.href));

      /*
       * Capture color clicks before the theme's native facets handler. This
       * guarantees that every click registers immediately and that Shopify
       * loads only once, 1.1 seconds after the customer's final color click.
       */
      document.addEventListener(
        'click',
        (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;

          const pill = target.closest('[data-color-group-pill]');
          if (!pill) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          this.queueColorGroupChange(pill);
        },
        true
      );
    }

    initColorSelectionBelts(newGroupKey = null) {
      const colorFilters = document.querySelectorAll('[data-premium-color-filter]');

      colorFilters.forEach((colorFilter) => {
        const selection = colorFilter.querySelector('[data-sq-color-belt-owned]');
        const belt = colorFilter.querySelector('[data-premium-color-selection-belt]');
        const clearButton = colorFilter.querySelector('.premium-color-selection__clear');
        const activeGroupedPills = Array.from(
          colorFilter.querySelectorAll('.premium-color-pill.is-active[data-color-group-pill]')
        );

        if (!selection || !belt) return;

        belt.replaceChildren();

        if (!activeGroupedPills.length) {
          selection.classList.remove('is-visible');
          selection.hidden = true;

          const fallbackParam = colorFilter.querySelector('[data-filter-param]')?.dataset.filterParam;
          if (fallbackParam) this.writeColorSelectionOrder(fallbackParam, []);
          return;
        }

        const filterParam = activeGroupedPills[0].dataset.filterParam;
        const activeByKey = new Map();

        activeGroupedPills.forEach((pill) => {
          const groupKey = pill.dataset.colorGroupKey;
          if (groupKey && !activeByKey.has(groupKey)) {
            activeByKey.set(groupKey, pill);
          }
        });

        const savedOrder = this.readColorSelectionOrder(filterParam);
        const orderedKeys = savedOrder.filter((key) => activeByKey.has(key));

        activeByKey.forEach((pill, key) => {
          if (!orderedKeys.includes(key)) orderedKeys.push(key);
        });

        this.writeColorSelectionOrder(filterParam, orderedKeys);

        orderedKeys.forEach((key) => {
          const sourcePill = activeByKey.get(key);
          if (!sourcePill) return;

          const labelElement = sourcePill.querySelector('.premium-color-pill__label');
          const label = labelElement ? labelElement.textContent.trim() : 'Color';
          const swatchColor = sourcePill.style.getPropertyValue('--premium-swatch-color').trim();

          const chip = document.createElement('a');
          chip.className = 'premium-selected-color-chip';
          if (key === newGroupKey) chip.classList.add('is-new');
          chip.href = sourcePill.href;
          chip.setAttribute('role', 'listitem');
          chip.setAttribute('aria-label', `Remove ${label} color filter`);
          chip.dataset.colorGroupKey = key;

          const swatch = document.createElement('span');
          swatch.className = 'premium-selected-color-chip__swatch';
          swatch.setAttribute('aria-hidden', 'true');

          if (swatchColor) {
            swatch.style.setProperty('--premium-selected-chip-color', swatchColor);
          }

          const chipLabel = document.createElement('span');
          chipLabel.className = 'premium-selected-color-chip__label';
          chipLabel.textContent = label;

          const removeIcon = document.createElement('span');
          removeIcon.className = 'premium-selected-color-chip__remove';
          removeIcon.setAttribute('aria-hidden', 'true');
          removeIcon.textContent = '×';

          chip.append(swatch, chipLabel, removeIcon);

          chip.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.queueColorGroupChange(sourcePill, { removeOnly: true });
          });

          belt.appendChild(chip);
        });

        if (clearButton && clearButton.dataset.colorOrderBound !== 'true') {
          clearButton.dataset.colorOrderBound = 'true';
          clearButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            window.clearTimeout(this.colorApplyTimer);
            window.clearTimeout(this.sizeApplyTimer);
            this.colorApplyTimer = null;
            this.sizeApplyTimer = null;

            const url = new URL(this.pendingColorUrl || this.pendingSizeUrl || window.location.href);

            this.getAllColorFilterParams(url).forEach((colorParam) => {
              url.searchParams.delete(colorParam);
            });

            url.searchParams.delete('page');
            this.pendingColorUrl = null;
            this.pendingSizeUrl = null;
            this.colorSelectionSessionActive = false;
            this.clearAllColorSelectionOrders();
            window.location.assign(url.toString());
          });
        }

        selection.hidden = false;
        selection.classList.remove('is-visible');

        window.requestAnimationFrame(() => {
          selection.classList.add('is-visible');

          if (newGroupKey) {
            belt.scrollTo({
              left: belt.scrollWidth,
              behavior: 'smooth'
            });
          }
        });
      });
    }


    getAllSizeFilterParams(url = null) {
      const params = new Set();

      document.querySelectorAll('[data-size-filter-pill][data-filter-param]').forEach((pill) => {
        const filterParam = pill.dataset.filterParam;
        if (filterParam) params.add(filterParam);
      });

      const sourceUrl = url || new URL(
        this.pendingSizeUrl || this.pendingColorUrl || window.location.href
      );

      sourceUrl.searchParams.forEach((value, key) => {
        if (/(^|[._-])size([._-]|$)/i.test(key)) params.add(key);
      });

      return Array.from(params);
    }

    isSizePillActiveInUrl(pill, url) {
      const filterParam = pill?.dataset.filterParam;
      const filterValue = pill?.dataset.filterValue;
      if (!filterParam || !filterValue) return false;

      return url.searchParams.getAll(filterParam).includes(filterValue);
    }

    syncSizePillStatesFromUrl(url) {
      document.querySelectorAll('[data-size-filter-pill]').forEach((pill) => {
        const isActive = this.isSizePillActiveInUrl(pill, url);
        pill.classList.toggle('is-active', isActive);
        pill.dataset.sizeActive = isActive ? 'true' : 'false';
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    scheduleSizeApply(url) {
      const destination = url.toString();
      this.pendingSizeUrl = destination;
      this.pendingColorUrl = destination;
      window.clearTimeout(this.sizeApplyTimer);
      window.clearTimeout(this.colorApplyTimer);

      this.sizeApplyTimer = window.setTimeout(() => {
        const nextDestination = this.pendingSizeUrl || this.pendingColorUrl;
        this.pendingSizeUrl = null;
        this.pendingColorUrl = null;
        this.sizeApplyTimer = null;
        this.colorApplyTimer = null;

        if (nextDestination) {
          window.location.assign(nextDestination);
        }
      }, this.sizeApplyDelay);
    }

    queueSizeChange(pill) {
      const filterParam = pill?.dataset.filterParam;
      const filterValue = pill?.dataset.filterValue;
      if (!filterParam || !filterValue) return;

      const url = new URL(
        this.pendingSizeUrl || this.pendingColorUrl || window.location.href
      );

      if (!this.sizeSelectionSessionActive) {
        this.sizeSelectionSessionActive = true;
        this.getAllSizeFilterParams(url).forEach((sizeParam) => {
          url.searchParams.delete(sizeParam);
        });
      }

      const wasActive = this.isSizePillActiveInUrl(pill, url);
      const remainingValues = url.searchParams
        .getAll(filterParam)
        .filter((value) => value !== filterValue);

      url.searchParams.delete(filterParam);
      remainingValues.forEach((value) => url.searchParams.append(filterParam, value));

      const shouldAdd = !wasActive;
      if (shouldAdd) url.searchParams.append(filterParam, filterValue);

      url.searchParams.delete('page');
      this.pendingSizeUrl = url.toString();
      this.pendingColorUrl = url.toString();
      this.syncSizePillStatesFromUrl(url);

      document.querySelectorAll('[data-size-filter-pill]').forEach((candidate) => {
        if (
          candidate.dataset.filterParam === filterParam &&
          candidate.dataset.filterValue === filterValue
        ) {
          candidate.classList.add(shouldAdd ? 'is-selecting' : 'is-removing');
        }
      });

      window.setTimeout(() => {
        document.querySelectorAll('[data-size-filter-pill]').forEach((candidate) => {
          if (
            candidate.dataset.filterParam === filterParam &&
            candidate.dataset.filterValue === filterValue
          ) {
            candidate.classList.remove('is-selecting', 'is-removing');
          }
        });
      }, 260);

      this.scheduleSizeApply(url);
    }

    initSizeGroups() {
      this.syncSizePillStatesFromUrl(new URL(window.location.href));

      document.addEventListener(
        'click',
        (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;

          const pill = target.closest('[data-size-filter-pill]');
          if (!pill) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          this.queueSizeChange(pill);
        },
        true
      );
    }


    initLegacyColorLabelsCleanup() {
      const normalizeText = (value) =>
        String(value || '')
          .replace(/[×✕✖]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

      const protectedSelector = [
        '[data-sq-color-belt-owned]',
        '[data-sq-color-belt-owned] [data-premium-color-selection-belt]',
        '.premium-filter-color-grid',
        '.premium-mobile-color-grid',
        '[data-color-group-pill]'
      ].join(', ');

      const legacyTitle = ['color', 'selection'].join(' ');
      const legacyPrompt = ['choose', 'one', 'or', 'more', 'colors'].join(' ');
      const commonLegacySelectors = [
        'facet-remove',
        '.active-facets__button',
        '.active-facets__button-wrapper',
        '.active-facets__item',
        '.facets__selected',
        '.facets__selected-value',
        '.facets__active',
        '.filter-group-display__header-selected',
        '[data-active-filter]',
        '[data-selected-value]'
      ].join(', ');

      const isProtected = (element) =>
        Boolean(element?.closest?.(protectedSelector));

      /*
       * The authored Color content has exactly two functional children:
       * our selected-color belt and the real primary-color swatch grid.
       * Any other direct child is the older before/after component injected
       * by the theme and is removed from the DOM rather than merely hidden.
       */
      const removeUnexpectedDirectChildren = (content) => {
        const selection = Array.from(content.children).find((element) =>
          element.matches('[data-sq-color-belt-owned]')
        );
        const grid = Array.from(content.children).find((element) =>
          element.matches('.premium-filter-color-grid, .premium-mobile-color-grid')
        );

        if (!selection || !grid) return;

        Array.from(content.childNodes).forEach((node) => {
          if (node === selection || node === grid) return;

          if (node.nodeType === Node.TEXT_NODE) {
            if (String(node.nodeValue || '').trim() === '') return;
            node.remove();
            return;
          }

          if (node.nodeType === Node.COMMENT_NODE) return;
          node.remove();
        });
      };

      const removeKnownLegacyControls = (colorFilter) => {
        /* Older iterations reused data-premium-color-selection. Keep only the
         * uniquely owned belt rendered by this file. */
        colorFilter
          .querySelectorAll('[data-premium-color-selection]:not([data-sq-color-belt-owned])')
          .forEach((element) => element.remove());

        colorFilter.querySelectorAll(commonLegacySelectors).forEach((element) => {
          if (!element.isConnected || isProtected(element)) return;
          element.remove();
        });
      };

      const removeExactLegacyPanels = (colorFilter) => {
        const candidates = Array.from(
          colorFilter.querySelectorAll(
            'div, section, aside, header, p, span, strong, small, label, button, a, li'
          )
        );

        candidates
          .filter((element) => {
            if (!element.isConnected || isProtected(element)) return false;
            if (element.closest('summary')) return false;
            if (element.querySelector(protectedSelector)) return false;

            const text = normalizeText(element.textContent);
            const hasTitle = text.includes(legacyTitle);
            const hasPrompt = text.includes(legacyPrompt);
            const hasCount = /(^|\s)\d+\s+selected($|\s)/.test(text);

            return (hasTitle && hasPrompt) || (hasTitle && hasCount) || (hasPrompt && hasCount);
          })
          .sort((a, b) => a.textContent.length - b.textContent.length)
          .forEach((element) => {
            if (element.isConnected) element.remove();
          });
      };

      const removeExactLegacyTextLeaves = (colorFilter) => {
        Array.from(colorFilter.querySelectorAll('*')).forEach((element) => {
          if (!element.isConnected || isProtected(element)) return;
          if (element.matches('details, summary, script, style, template')) return;
          if (element.children.length > 0) return;

          const text = normalizeText(element.textContent);
          const isLegacyLine =
            text === legacyTitle ||
            text === legacyPrompt ||
            /^\d+\s+selected$/.test(text);

          if (isLegacyLine) element.remove();
        });
      };

      const cleanupRoot = (root) => {
        root.querySelectorAll('[data-premium-color-content]').forEach((content) => {
          removeUnexpectedDirectChildren(content);
        });

        root.querySelectorAll('[data-premium-color-filter]').forEach((colorFilter) => {
          removeKnownLegacyControls(colorFilter);
          removeExactLegacyPanels(colorFilter);
          removeExactLegacyTextLeaves(colorFilter);
        });

        root.querySelectorAll('*').forEach((element) => {
          if (element.shadowRoot) cleanupRoot(element.shadowRoot);
        });
      };

      const cleanup = () => cleanupRoot(document);
      let cleanupFrame = null;

      const scheduleCleanup = () => {
        if (cleanupFrame) return;

        cleanupFrame = window.requestAnimationFrame(() => {
          cleanupFrame = null;
          cleanup();
        });
      };

      cleanup();
      window.setTimeout(cleanup, 80);
      document.addEventListener('shopify:section:load', scheduleCleanup);

      /*
       * Watch only the two Color accordions. The former document-wide observer
       * rescanned the entire collection whenever products or attributes changed,
       * which contributed to the jerky filter scroll.
       */
      document.querySelectorAll('[data-premium-color-filter]').forEach((colorFilter) => {
        const observer = new MutationObserver(scheduleCleanup);
        observer.observe(colorFilter, {
          childList: true,
          subtree: true,
          characterData: true
        });
      });
    }

    findProductGrid() {
      const selectors = [
        '#product-grid',
        '.product-grid',
        '.grid.product-grid',
        '.collection .grid',
        '.collection__products .grid',
        'product-grid',
        'ul.grid'
      ];

      for (const selector of selectors) {
        const grid = document.querySelector(selector);
        if (grid) return grid;
      }

      return null;
    }

    applyDensityToGrid(density) {
      const grid = this.findProductGrid();

      document.body.classList.remove('premium-density-2', 'premium-density-3', 'premium-density-4');
      document.body.classList.add(`premium-density-${density}`);

      if (grid) {
        grid.style.setProperty('display', 'grid', 'important');
        grid.style.setProperty('grid-template-columns', `repeat(${density}, minmax(0, 1fr))`, 'important');

        Array.from(grid.children).forEach((child) => {
          child.style.setProperty('width', 'auto', 'important');
          child.style.setProperty('max-width', 'none', 'important');
          child.style.setProperty('flex', 'unset', 'important');
        });
      }
    }

    applyMobileDensityToGrid(density) {
      const grid = this.findProductGrid();

      document.body.classList.remove('premium-mobile-density-1', 'premium-mobile-density-2');
      document.body.classList.add(`premium-mobile-density-${density}`);

      if (window.matchMedia('(max-width: 749px)').matches && grid) {
        grid.style.setProperty('display', 'grid', 'important');
        grid.style.setProperty('grid-template-columns', `repeat(${density}, minmax(0, 1fr))`, 'important');

        Array.from(grid.children).forEach((child) => {
          child.style.setProperty('width', 'auto', 'important');
          child.style.setProperty('max-width', 'none', 'important');
          child.style.setProperty('flex', 'unset', 'important');
        });
      }
    }

    initDensity() {
      const storedDensity = localStorage.getItem('premiumProductDensity');
      const savedDensity = ['2', '3', '4'].includes(storedDensity) ? storedDensity : '4';

      const applyDensity = (density) => {
        this.applyDensityToGrid(density);

        this.densityButtons.forEach((button) => {
          button.classList.toggle('is-active', button.dataset.premiumDensity === density);
        });

        localStorage.setItem('premiumProductDensity', density);
      };

      this.densityButtons.forEach((button) => {
        button.addEventListener('click', () => {
          applyDensity(button.dataset.premiumDensity);
        });
      });

      applyDensity(savedDensity);

      document.addEventListener('shopify:section:load', () => {
        applyDensity(localStorage.getItem('premiumProductDensity') || '4');
      });
    }

    initMobileDensity() {
      const storedMobileDensity = localStorage.getItem('premiumMobileProductDensity');
      const savedMobileDensity = ['1', '2'].includes(storedMobileDensity) ? storedMobileDensity : '2';

      const applyMobileDensity = (density) => {
        this.applyMobileDensityToGrid(density);

        this.mobileDensityButtons.forEach((button) => {
          button.classList.toggle('is-active', button.dataset.premiumMobileDensity === density);
        });

        localStorage.setItem('premiumMobileProductDensity', density);
      };

      this.mobileDensityButtons.forEach((button) => {
        button.addEventListener('click', () => {
          applyMobileDensity(button.dataset.premiumMobileDensity);
        });
      });

      applyMobileDensity(savedMobileDensity);

      document.addEventListener('shopify:section:load', () => {
        const currentDensity = localStorage.getItem('premiumMobileProductDensity');

        if (['1', '2'].includes(currentDensity)) {
          applyMobileDensity(currentDensity);
        } else {
          applyMobileDensity('2');
        }
      });

      window.addEventListener('resize', () => {
        const currentDensity = localStorage.getItem('premiumMobileProductDensity');

        if (['1', '2'].includes(currentDensity)) {
          applyMobileDensity(currentDensity);
        } else {
          applyMobileDensity('2');
        }
      });
    }

    initMobileDrawer() {
      const drawer = document.querySelector('[data-premium-mobile-filter-drawer]');
      const panel = document.querySelector('[data-premium-mobile-filter-panel]');
      const openButtons = document.querySelectorAll('[data-premium-mobile-filter-open]');
      const closeButtons = document.querySelectorAll('[data-premium-mobile-filter-close]');

      if (!drawer || !panel || !openButtons.length) return;

      let startX = 0;
      let currentX = 0;
      let dragging = false;

      const openDrawer = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('premium-mobile-filter-is-open');

        openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'true');
        });

        setTimeout(() => {
          panel.focus();
        }, 60);
      };

      const closeDrawer = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('premium-mobile-filter-is-open');

        openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });

        panel.style.transform = '';
      };

      openButtons.forEach((button) => {
        button.addEventListener('click', openDrawer);
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', closeDrawer);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });

      panel.addEventListener(
        'touchstart',
        (event) => {
          if (!drawer.classList.contains('is-open')) return;

          startX = event.touches[0].clientX;
          currentX = startX;
          dragging = true;
          panel.style.transition = 'none';
        },
        { passive: true }
      );

      panel.addEventListener(
        'touchmove',
        (event) => {
          if (!dragging) return;

          currentX = event.touches[0].clientX;
          const deltaX = Math.min(0, currentX - startX);

          panel.style.transform = `translateX(${deltaX}px)`;
        },
        { passive: true }
      );

      panel.addEventListener('touchend', () => {
        if (!dragging) return;

        const deltaX = currentX - startX;
        dragging = false;
        panel.style.transition = '';

        if (deltaX < -72) {
          closeDrawer();
        } else {
          panel.style.transform = '';
        }
      });
    }

    initMobileSortClose() {
      const sortMenus = document.querySelectorAll('.premium-mobile-sort-menu');

      if (!sortMenus.length) return;

      const closeAllSortMenus = () => {
        sortMenus.forEach((menu) => {
          menu.removeAttribute('open');
        });
      };

      sortMenus.forEach((menu) => {
        const select = menu.querySelector('select');

        if (select) {
          select.addEventListener('change', () => {
            closeAllSortMenus();
          });
        }
      });

      document.addEventListener('click', (event) => {
        sortMenus.forEach((menu) => {
          if (!menu.contains(event.target)) {
            menu.removeAttribute('open');
          }
        });
      });

      window.addEventListener('scroll', closeAllSortMenus, { passive: true });
      window.addEventListener('wheel', closeAllSortMenus, { passive: true });
      window.addEventListener('touchmove', closeAllSortMenus, { passive: true });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeAllSortMenus();
        }
      });
    }

    initMobileMenuProtection() {
      const root = document.documentElement;
      const body = document.body;

      const closeSortMenus = () => {
        document.querySelectorAll('.premium-mobile-sort-menu[open]').forEach((menu) => {
          menu.removeAttribute('open');
        });
      };

      const isMobileMenuOpen = () => {
        const openMenuDrawer = document.querySelector(
          '#Details-menu-drawer-container[open], .menu-drawer-container[open], details[open] > .menu-drawer, details[open] .menu-drawer'
        );

        if (openMenuDrawer) return true;

        const menuOpeningClass = document.querySelector(
          '.menu-opening, .menu-drawer-container.menu-opening, .shopify-section-header-menu-open'
        );

        if (menuOpeningClass) return true;

        const expandedMenuButtons = Array.from(
          document.querySelectorAll(
            '.header__icon--menu, [aria-controls*="menu"], [aria-controls*="Menu"], [aria-controls*="drawer"], [aria-controls*="Drawer"]'
          )
        );

        return expandedMenuButtons.some((button) => {
          return button.getAttribute('aria-expanded') === 'true';
        });
      };

      const syncMenuState = () => {
        const menuIsOpen = isMobileMenuOpen();

        root.classList.toggle('premium-mobile-menu-is-open', menuIsOpen);
        body.classList.toggle('premium-mobile-menu-is-open', menuIsOpen);

        if (menuIsOpen) {
          closeSortMenus();
        }
      };

      syncMenuState();

      document.addEventListener(
        'click',
        () => {
          window.setTimeout(syncMenuState, 0);
          window.setTimeout(syncMenuState, 220);
        },
        true
      );

      document.addEventListener(
        'keydown',
        () => {
          window.setTimeout(syncMenuState, 0);
          window.setTimeout(syncMenuState, 220);
        },
        true
      );

      window.addEventListener('resize', syncMenuState);
      document.addEventListener('shopify:section:load', syncMenuState);

      const observer = new MutationObserver(syncMenuState);
      const menuObserverRoot =
        document.querySelector('#shopify-section-header, .shopify-section-header, header') ||
        document.body;

      observer.observe(menuObserverRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'open', 'aria-expanded']
      });
    }

    getNextPageUrl() {
      const selectors = [
        'a[rel="next"]',
        '.pagination__item--next',
        '.pagination a[href*="page="]:last-of-type',
        'a[href*="page="][aria-label*="Next"]',
        'a[href*="page="][aria-label*="next"]'
      ];

      for (const selector of selectors) {
        const link = document.querySelector(selector);
        if (link && link.href) return link.href;
      }

      return null;
    }

    initInfiniteScroll() {
      const grid = this.findProductGrid();

      if (!grid) return;

      const sentinel = document.createElement('div');
      sentinel.className = 'premium-infinite-scroll-sentinel';
      sentinel.style.width = '100%';
      sentinel.style.height = '1px';

      grid.insertAdjacentElement('afterend', sentinel);

      const loadNextPage = async () => {
        if (this.loadingNextPage) return;

        const nextUrl = this.getNextPageUrl();

        if (!nextUrl) {
          sentinel.remove();
          return;
        }

        this.loadingNextPage = true;

        try {
          const response = await fetch(nextUrl);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const currentGrid = this.findProductGrid();
          const nextGrid =
            doc.querySelector('#product-grid') ||
            doc.querySelector('.product-grid') ||
            doc.querySelector('.grid.product-grid') ||
            doc.querySelector('.collection .grid') ||
            doc.querySelector('.collection__products .grid') ||
            doc.querySelector('ul.grid');

          if (!currentGrid || !nextGrid) {
            sentinel.remove();
            this.loadingNextPage = false;
            return;
          }

          Array.from(nextGrid.children).forEach((item) => {
            currentGrid.appendChild(item);
          });

          const currentPagination =
            document.querySelector('.pagination-wrapper') ||
            document.querySelector('.pagination') ||
            document.querySelector('nav[role="navigation"]');

          const nextPagination =
            doc.querySelector('.pagination-wrapper') ||
            doc.querySelector('.pagination') ||
            doc.querySelector('nav[role="navigation"]');

          if (currentPagination && nextPagination) {
            currentPagination.innerHTML = nextPagination.innerHTML;
          } else if (currentPagination) {
            currentPagination.remove();
          }

          const currentDesktopDensity = localStorage.getItem('premiumProductDensity');

          if (['2', '3', '4'].includes(currentDesktopDensity)) {
            this.applyDensityToGrid(currentDesktopDensity);
          } else {
            this.applyDensityToGrid('4');
          }

          const currentMobileDensity = localStorage.getItem('premiumMobileProductDensity');

          if (['1', '2'].includes(currentMobileDensity)) {
            this.applyMobileDensityToGrid(currentMobileDensity);
          } else {
            this.applyMobileDensityToGrid('2');
          }
        } catch (error) {
          sentinel.remove();
        }

        this.loadingNextPage = false;
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadNextPage();
            }
          });
        },
        {
          rootMargin: '900px 0px'
        }
      );

      observer.observe(sentinel);
    }
  }

  new PremiumHorizontalFacets();
  } catch(e) { console.error(e); }
})();

})();
